import React, { ChangeEvent, useState, useEffect } from 'react'
import InputSearch from '../../InputSearch'
import { ConnectedProducersListHeaderProps } from './types'
import { useTranslation } from 'react-i18next'
import { isBrowser } from '../../../Utils/Utils'
import './Scss/connected-producers-list-header.scss';

const ConnectedProducersListHeader = (
    props: ConnectedProducersListHeaderProps
) => {
    const { t } = useTranslation()
    const [search, setSearch] = useState<string>('')
    const [autoCompleteValue, setAutoCompleteValue] = useState<string>('off')

    const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setSearch(value)
        props.onSearch(value)
    }

    useEffect(() => {
        if (isBrowser) {
            const inputsOnPage = document.querySelectorAll('input')?.length || 0
            // Site searchinput + this input = 2.
            // If there are more fields, we need this piece of magic to turn off autocomplete.
            if (inputsOnPage > 2) {
                setAutoCompleteValue('should-not-autocomplete')
            }
        }
    }, [])

    return (
        <div className={'connected-producers-list-header'}>
            <div className={'connected-producers-list-header__search'}>
                {props.heading && <h2>{props.heading}</h2>}
                <InputSearch
                    id="producers-search"
                    autoComplete={autoCompleteValue}
                    label=""
                    value={search}
                    onChange={onChangeSearch}
                    placeholder={t(
                        'connectedProducersListBlock.searchPlaceholder'
                    )}
                />
            </div>
        </div>
    )
}

export default ConnectedProducersListHeader
